import { Component, OnInit } from "@angular/core";
import { VersionCheckService } from "./services/common/version-check.service";
import { environment } from "src/environments/environment";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html"
})
export class AppComponent implements OnInit {
  constructor(
    private titleService: Title,
    private versionCheckService: VersionCheckService,
  ) {}
  title = "gonbad-web";

  ngOnInit(): void {
    this.setTitle();
    this.versionCheckService.initVersionCheck(environment.versionCheckURL)
  }

  public setTitle() {
    this.titleService.setTitle(environment.siteTitle);
  }
}
